import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ResbuildmngCovarage from "./ResbuildmngCovarage"
import ResbuildmngBuildinglife from "./ResbuildmngBuildinglife"
import AddIcon from "@material-ui/icons/Add"
import ResbuildmngFinanceMedic from "./ResbuildmngFinanceMedic";
import ResbuildmngBuildingType from "./ResbuildmngBuildingType";
import ResbuildmngBuildingTypeOfCons from "./ResbuildmngBuildingTypeOfCons";
import ResBossToEmployeeCovarage from "./ResBossToEmployeeCovarage";
import ResBossToEmployeeRangePerson from "./ResBossToEmployeeRangePerson";
import ResBossToEmployeeSelectabelDiscount from "./ResBossToEmployeeSelectabelDiscount";
import ResBossToEmployeeRangeDiscount from "./ResBossToEmployeeRangeDiscount";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceResbuildmng extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  boss_to_employee_price_id: "",
                  atonementSolventPrice: "",
                  coefficientAtonementSolventPrice: "",
                  person_quantity: "",
                  percent_range_discount: "",
                  atonementIllegalPrice: "",
                  coefficientIllegalSolventPrice: "",
                  resbuildmng_price_chashdisc: "",
                  alpha: "",
                  selectedCompany: "",
                  selectedKind: "",
                  selectedFinancemedic: "",
                  selectedTypeofcons: "",
                  resbuildmng_price_deactive: "0",
                  resbuildmng_price_process_mode: "0",
                  company_logo_url: "",
                  orderBy: "boss_to_employee_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceResbuildmng: true,
                  optionCompany: [],
                  optionKind: [],
                  optionFinancemedic: [],
                  optionTypeofcons: [],
                  openDialog: false,
                  resBuildmngCovarage: [],
                  resBuildmngFinanceMedic: [],
                  resbuildmngBuildinglife: [],
                  resbuildmngBuildingType: [],
                  resbuildmngBuildingTypeOfCons: [],
                  resbuildmngBuildingTypeOfCons_discount: [],
                  resbuildmng_price_covarage_percent: "",
                  resbuildmng_price_buildinglife_percent: "",
                  resbuildmng_price_kind_percent: "",
                  resbuildmng_price_typeofcons_percent: "",
                  selectedResbuildmngCoverage: "",
                  selectedResbuildmngBuildinglife: "",
                  selectedResbuildmngBuildingُType: "",
                  selectedResbuildmngBuildingُTypeOfCons: "",
                  from_area: "",
                  from_area_discount: "",
                  to_area : "",
                  to_area_discount : ""
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeFromYear = (event) => {
            this.setState({ atonementSolventPrice: event })
      }
      handleChangecoefficientAtonementSolventPrice = (event) =>{
            this.setState({ coefficientAtonementSolventPrice: event })

      }
      handleChangecoefficientIllegalSolventPrice = (event) => {
            this.setState({ coefficientIllegalSolventPrice: event })
      }

      handleChangeAmount = (event) => {
            this.setState({ person_quantity: event })
      }
      handleChangeAmount_discount = (event) => {
            this.setState({ percent_range_discount: event })
      }

      handleChangeToYear = (event) => {
            this.setState({ atonementIllegalPrice: event })
      }
      handleChangecoefficientIllegalSolventPrice = (event) => {
            this.setState({ coefficientIllegalSolventPrice: event })
      }
      handleChangeFromUnit = (event) => {
            this.setState({ from_area: event })
      }
      handleChangeFromUnit_discount = (event) => {
            this.setState({ from_area_discount: event })
      }
      handleChangeToUnit = (event) => {
            this.setState({ to_area: event })
      }
      handleChangeToUnit_discount = (event) => {
            this.setState({ to_area_discount: event })
      }
      handleChangeDisc = (event) => {
            this.setState({ alpha: event })
      }
      handleFinancemedic = (selectedFinancemedic) => {
            this.setState({ selectedFinancemedic: selectedFinancemedic }, () => {})
      }

      handleTypeofcons = (selectedTypeofcons) => {
            this.setState({ selectedTypeofcons: selectedTypeofcons }, () => {})
      }

      handleKind = (selectedKind) => {
            this.setState({ selectedKind: selectedKind }, () => {
                  this.filterPriceResbuildmng()
            })
      }


      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceResbuildmng()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ resbuildmng_price_deactive: "0" })
            } else {
                  this.setState({ resbuildmng_price_deactive: "1" })
            }
      }


      handleResbuildmngCoverage = (selectedResbuildmngCoverage) => {
            this.setState({ selectedResbuildmngCoverage: selectedResbuildmngCoverage })
      }

      handleResbuildmngBuildinglife = (selectedResbuildmngBuildinglife) => {
            this.setState({ selectedResbuildmngBuildinglife: selectedResbuildmngBuildinglife })
      }
      handleResbuildmngBuildingType = (selectedResbuildmngBuildingُType) => {
            this.setState({ selectedResbuildmngBuildingُType: selectedResbuildmngBuildingُType })
      }
      handleResbuildmngBuildingTypeOfCons = (selectedResbuildmngBuildingُTypeOfCons) => {
            this.setState({ selectedResbuildmngBuildingُTypeOfCons: selectedResbuildmngBuildingُTypeOfCons })
      }

      handleChangeExtrafinancialPrice = (event) => {
            this.setState({ resbuildmng_price_covarage_percent: event })
      }

      handleChangeResbuildmngBuildinglife = (event) => {
            this.setState({ resbuildmng_price_buildinglife_percent: event })
      }
      handleChangeResbuildmngBuildingType = (event) => {
            this.setState({ resbuildmng_price_kind_percent: event })
      }
      handleChangeResbuildmngBuildingTypeOfCons = (event) => {
            this.setState({ resbuildmng_price_typeofcons_percent: event })
      }
      getPersonRange = (price_id) =>{
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ resBuildmngFinanceMedic: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ resBuildmngFinanceMedic: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_range_person")
                  fd.append("boss_to_employee_range_person_price_id", price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      deleteManagdiscount = () => {
            const { boss_to_employee_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPrice()

                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price")
            fd.append("boss_to_employee_price_id", boss_to_employee_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }


      getpriceCovarage = (price_id) => {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ resBuildmngCovarage: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ resBuildmngCovarage: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_coverage")
                  fd.append("boss_to_employee_price_id", price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      handleSelectRows = (row2) => {
            this.getpriceCovarage(row2.boss_to_employee_price_id)
            this.getPersonRange(row2.boss_to_employee_price_id)
            this.getresbuildmngBuildingTypeOfCons(row2.boss_to_employee_price_id)
            this.getresbuildmngBuildingTypeOfCons_discount(row2.boss_to_employee_price_id)
            // this.getresbuildmngBuildinglife(row2.boss_to_employee_price_id)
            // this.getresbuildmngBuildingType(row2.boss_to_employee_price_id)
            // this.getresbuildmngBuildingTypeOfCons(row2.boss_to_employee_price_id)
console.log("dfsdfsfsd",row2)
            this.setState(
                  {
                        boss_to_employee_price_id: row2.boss_to_employee_price_id,
                        atonementSolventPrice: row2.boss_to_employee_price_atonement_solvent,
                        coefficientAtonementSolventPrice: row2.boss_to_employee_price_coef_atonement_solvent,
                        // person_quantity: row2.person_quantity,
                        atonementIllegalPrice: row2.boss_to_employee_price_illegal_solvent,
                        coefficientIllegalSolventPrice: row2.boss_to_employee_price_coef_illegal_solvent,
                        // resbuildmng_price_chashdisc: row2.resbuildmng_price_chashdisc,
                        alpha: row2.boss_to_employee_price_alpha,

                        selectedCompany: { value: row2.resbuildmng_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedKind: { value: row2.resbuildmng_price_kind_id, label: row2.resbuildmng_kind_name },
                        selectedTypeOfCons: { value: row2.resbuildmng_price_typeofcons_id, label: row2.resbuildmng_typeofcons_name },
                        selectedFinancemedic: { value: row2.resbuildmng_price_financemedic_id, label: row2.resbuildmng_financemedic_name },
                        selectedTypeofcons: { value: row2.resbuildmng_price_typeofcons_id, label: row2.resbuildmng_typeofcons_name },

                        resbuildmng_price_deactive: row2.boss_to_employee_price_deactive,
                        resbuildmng_price_process_mode: row2.resbuildmng_price_process_mode,
                        company_logo_url: row2.company_logo_url,
                        newPriceResbuildmng: false,
                  },
                  () => {}
            )
      }

      newPriceResbuildmng = (event) => {
            this.setState({
                  boss_to_employee_price_id: "",
                  atonementSolventPrice: "",
                  coefficientAtonementSolventPrice: "",
                  person_quantity: "",
                  percent_range_discount: "",
                  atonementIllegalPrice: "",
                  coefficientIllegalSolventPrice: "",
                  resbuildmng_price_chashdisc: "",
                  alpha: "",
                  selectedCompany: "",
                  selectedKind: "",
                  selectedFinancemedic: "",
                  selectedTypeofcons: "",
                  resbuildmng_price_deactive: "0",
                  resbuildmng_price_process_mode: "0",
                  company_logo_url: "",
                  newPriceResbuildmng: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionCompany()
                                    self.getoptionKind()
                                    self.getoptionTypeofcons()
                                    self.getPrice()



                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }


      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              if (arr.data.length>0) {
                                self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                  })
                              }

                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "boss_to_employee")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].boss_to_employee_coverage_id, label: arr.data[k].boss_to_employee_coverage_name })
                              }
                              self.setState({ optionKind: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.send(fd)
      }


      getoptionTypeofcons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].boss_to_employee_discount_id, label: arr.data[k].boss_to_employee_discount_desc })
                              }
                              self.setState({ optionResbuildmngBuildingTypeOfCons: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discount")
            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.send(fd)
      }

      saveNewPriceResbuildmng = () => {
            const {
                  atonementSolventPrice,
                  coefficientAtonementSolventPrice,
                  atonementIllegalPrice,
                  coefficientIllegalSolventPrice,
                  alpha,
                  selectedCompany,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
            } = this.state
            if (
                  selectedCompany != "" &&
                  atonementSolventPrice != "" &&
                coefficientAtonementSolventPrice != "" &&
                atonementIllegalPrice != "" &&
                  coefficientIllegalSolventPrice != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.getPrice()
                                    //self.setState({ redirect: true })
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price")
                  fd.append("boss_to_employee_price_atonement_solvent", atonementSolventPrice)
                  fd.append("boss_to_employee_price_coef_atonement_solvent", coefficientAtonementSolventPrice)
                  fd.append("boss_to_employee_price_illegal_solvent", atonementIllegalPrice)
                  fd.append("boss_to_employee_price_coef_illegal_solvent", coefficientIllegalSolventPrice)
                  fd.append("boss_to_employee_price_alpha", alpha)
                  fd.append("boss_to_employee_price_fieldcompany_id", selectedCompany.value)
                  fd.append("boss_to_employee_price_deactive", resbuildmng_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResbuildmngCoverage = () => {
            const { boss_to_employee_price_id, selectedKind, resbuildmng_price_covarage_percent } = this.state
            if (selectedKind != "" && resbuildmng_price_covarage_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_covarage_percent: "", selectedKind: "" })
                                    self.getpriceCovarage(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_coverage")
                  fd.append("boss_to_employee_price_coverage_b2emp_price_id", boss_to_employee_price_id)
                  fd.append("boss_to_employee_price_coverage_percent", resbuildmng_price_covarage_percent)
                  fd.append("boss_to_employee_price_coverage_b2emp_coverage_id", selectedKind.value)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResbuildmngFinanceMedic = () => {
            const { boss_to_employee_price_id, selectedFinancemedic, from_area,  to_area, person_quantity} = this.state
            if (from_area != "" && to_area != "" && person_quantity != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ from_area : "" , to_area : "", person_quantity : "" , selectedFinancemedic : "" })
                                    self.getPersonRange(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_range_person")
                  fd.append("boss_to_employee_range_person_price_id", boss_to_employee_price_id)
                  fd.append("boss_to_employee_range_person_from_area", from_area)
                  fd.append("boss_to_employee_range_person_to_area", to_area)
                  fd.append("boss_to_employee_range_person_quantity", person_quantity)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceResbuildmngFinanceMedic_discount = () => {
            const { boss_to_employee_price_id, selectedFinancemedic, from_area_discount,  to_area_discount, percent_range_discount} = this.state
            if (from_area_discount != "" && to_area_discount != "" && percent_range_discount != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ from_area_discount : "" , to_area_discount : "", percent_range_discount : "" , selectedFinancemedic : "" })
                                    self.getresbuildmngBuildingTypeOfCons_discount(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_range_discount")
                  fd.append("boss_to_employee_price_range_discount_price_id", boss_to_employee_price_id)
                  fd.append("boss_to_employee_price_range_discount_from_area", from_area_discount)
                  fd.append("boss_to_employee_price_range_discount_to_area", to_area_discount)
                  fd.append("boss_to_employee_price_range_discount_percent", percent_range_discount)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      saveNewPriceResbuildmngBuildinglife = () => {
            const { boss_to_employee_price_id, selectedResbuildmngBuildinglife, resbuildmng_price_buildinglife_percent } = this.state
            if (selectedResbuildmngBuildinglife != "" && resbuildmng_price_buildinglife_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_buildinglife_percent: "", selectedResbuildmngBuildinglife: "" })
                                    self.getresbuildmngBuildinglife(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_buildinglife")
                  fd.append("resbuildmng_price_buildinglife_resbuildmng_price_id", boss_to_employee_price_id)
                  fd.append("resbuildmng_price_buildinglife_percent", resbuildmng_price_buildinglife_percent)
                  fd.append("resbuildmng_price_buildinglife_resbuildmng_buildinglife_id", selectedResbuildmngBuildinglife.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceResbuildmngBuildingType = () => {
            const { boss_to_employee_price_id, selectedResbuildmngBuildingُType, resbuildmng_price_kind_percent } = this.state
            if (selectedResbuildmngBuildingُType != "" && resbuildmng_price_kind_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_kind_percent: "", selectedResbuildmngBuildingُType: "" })
                                    self.getresbuildmngBuildingType(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_kind")
                  fd.append("resbuildmng_price_kind_resbuildmng_price_id", boss_to_employee_price_id)
                  fd.append("resbuildmng_price_kind_percent", resbuildmng_price_kind_percent)
                  fd.append("resbuildmng_price_kind_resbuildmng_kind_id", selectedResbuildmngBuildingُType.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      getresbuildmngBuildingTypeOfCons(resbuildmng_price_id) {
            this.setState({ resbuildmngBuildingTypeOfCons: [] }, () => {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ resbuildmngBuildingTypeOfCons: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_selectable_discount")
                  fd.append("boss_to_employee_price_discount_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getresbuildmngBuildingTypeOfCons_discount(resbuildmng_price_id) {
            this.setState({ resbuildmngBuildingTypeOfCons_discount: [] }, () => {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ resbuildmngBuildingTypeOfCons_discount: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_range_discount")
                  fd.append("boss_to_employee_range_person_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      saveNewPriceResbuildmngBuildingTypeOfCons = () => {
            const { boss_to_employee_price_id, selectedResbuildmngBuildingُTypeOfCons, resbuildmng_price_typeofcons_percent } = this.state
            if (selectedResbuildmngBuildingُTypeOfCons != "" && resbuildmng_price_typeofcons_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_typeofcons_percent: "", selectedResbuildmngBuildingُTypeOfCons: "" })
                                    self.getresbuildmngBuildingTypeOfCons(boss_to_employee_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_selectable_discount")
                  fd.append("boss_to_employee_price_discount_price_id", boss_to_employee_price_id)
                  fd.append("boss_to_employee_price_discount_percent", resbuildmng_price_typeofcons_percent)
                  fd.append("boss_to_employee_price_discount_discount_id", selectedResbuildmngBuildingُTypeOfCons.value)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      getPrice  = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceResbuildmng()
                                    })
                              } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_price")
            xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
            xhttp.send(fd)
      }

      changePriceResbuildmng = () => {
            const {
                  boss_to_employee_price_id,
                  atonementSolventPrice,
                  coefficientAtonementSolventPrice,
                  person_quantity,
                  percent_range_discount,
                  atonementIllegalPrice,
                  coefficientIllegalSolventPrice,
                  resbuildmng_price_chashdisc,
                  alpha,
                  selectedCompany,
                  selectedKind,
                  selectedFinancemedic,
                  selectedTypeofcons,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
            } = this.state
            if (
                  selectedCompany != "" &&
                  atonementSolventPrice != "" &&
                coefficientAtonementSolventPrice != "" &&
                atonementIllegalPrice != ""&&
                coefficientIllegalSolventPrice != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPrice()

                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_price")
                  fd.append("boss_to_employee_price_id", boss_to_employee_price_id)
                  fd.append("boss_to_employee_price_atonement_solvent", atonementSolventPrice)
                  fd.append("boss_to_employee_price_coef_atonement_solvent", coefficientAtonementSolventPrice)
                  fd.append("boss_to_employee_price_illegal_solvent", atonementIllegalPrice)
                  fd.append("boss_to_employee_price_coef_illegal_solvent", coefficientIllegalSolventPrice)
                  fd.append("boss_to_employee_price_alpha", alpha)
                  fd.append("boss_to_employee_price_deactive", resbuildmng_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/BossToEmployee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceResbuildmng = () => {
            const { selectedCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
                  console.log(temparray)

            for (i = 0; i < temparray.length; i++) {
                  console.log(temparray[i].boss_to_employee_price_fieldcompany_id,selectedCompany.value)
                  if (
                        (selectedCompany.value === 0 || temparray[i].boss_to_employee_price_fieldcompany_id === selectedCompany.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            console.log(temparray2)

            this.setState({ agentInfofilter: temparray2 }, () => {})
      }



      render() {
            const { classes } = this.props
            const {
                  resbuildmng_price_covarage_percent,
                  resbuildmng_price_buildinglife_percent,
                  resbuildmng_price_kind_percent,
                  resbuildmng_price_typeofcons_percent,
                  selectedResbuildmngCoverage,
                  selectedResbuildmngBuildinglife,
                  selectedResbuildmngBuildingُType,
                  selectedResbuildmngBuildingُTypeOfCons,
                  optionCompany,
                  optionResbuildmngCoverage,
                  optionResbuildmngBuildinglife,
                  optionResbuildmngBuildingType,
                  optionResbuildmngBuildingTypeOfCons,
                  optionKind,
                  optionFinancemedic,
                  optionTypeofcons,
                  resBuildmngCovarage,
                  resBuildmngFinanceMedic,
                  resbuildmngBuildinglife,
                  resbuildmngBuildingType,
                  resbuildmngBuildingTypeOfCons,
                  resbuildmngBuildingTypeOfCons_discount,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceResbuildmng,
                  boss_to_employee_price_id,
                  atonementSolventPrice,
                  coefficientAtonementSolventPrice,
                  person_quantity,
                  percent_range_discount,
                  atonementIllegalPrice,
                  coefficientIllegalSolventPrice,
                  resbuildmng_price_chashdisc,
                  alpha,
                  company_logo_url,
                  selectedCompany,
                  selectedKind,
                  selectedFinancemedic,
                  selectedTypeofcons,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                from_area,
            from_area_discount,
                to_area,
                  to_area_discount

            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    {/*PRICE ITSELF*/}
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه کارفرما در قبال کارگران: " + boss_to_employee_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>




                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="دیه ماه حلال"
                                                                        handleInputt={this.handleChangeFromYear}
                                                                        value={atonementSolventPrice}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <FloatingLabelInput
                                                                      type="number"
                                                                      placeholder="ضریب دیه ماه حلال"
                                                                      handleInputt={this.handleChangecoefficientAtonementSolventPrice}
                                                                      value={coefficientAtonementSolventPrice}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="دیه ماه حرام"
                                                                        handleInputt={this.handleChangeToYear}
                                                                        value={atonementIllegalPrice}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <FloatingLabelInput
                                                                      type="number"
                                                                      placeholder="ضریب دیه ماه حرام"
                                                                      handleInputt={this.handleChangecoefficientIllegalSolventPrice}
                                                                      value={coefficientIllegalSolventPrice}
                                                                  />
                                                            </Grid>
                                                            {/*<Grid item xs={4}>*/}
                                                            {/*      <FloatingLabelInput*/}
                                                            {/*          type="percent"*/}
                                                            {/*          placeholder="مبلغ حق بیمه هر واحد"*/}
                                                            {/*          handleInputt={this.handleChangeAmount}*/}
                                                            {/*          value={person_quantity}*/}
                                                            {/*      />*/}
                                                            {/*</Grid>*/}

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="الفا"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={alpha}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={resbuildmng_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {newPriceResbuildmng ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceResbuildmng}
                                                                        >
                                                                              {"ثبت قیمت بیمه کارفرما قبال کاگر جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceResbuildmng}
                                                                              >
                                                                                    {"قیمت بیمه کارفرما قبال کاگر جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceResbuildmng}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه مدیر ساختمان"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceResbuildmng ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    {/*    FINANCE MEDIC COVERAGE  */}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resBuildmngFinanceMedic.map((bfm, index) => (

                                                                    <ResBossToEmployeeRangePerson
                                                                        resBuildmngFinanceMedic={bfm}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>

                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>

                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="از متر مربع "
                                                                                handleInputt={this.handleChangeFromUnit}
                                                                                value={from_area}
                                                                            />
                                                                      </Grid>
                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder=" تا متر مربع "
                                                                                handleInputt={this.handleChangeToUnit}
                                                                                value={to_area}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder=" تعداد نفر "
                                                                                handleInputt={this.handleChangeAmount}
                                                                                value={person_quantity}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={2}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngFinanceMedic}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>



                                    {/* EXTRA COVERAGE */}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12}>
                                                                  {resBuildmngCovarage.map((resBuildmngCovarage, index) => (
                                                                        <ResBossToEmployeeCovarage
                                                                              bossToEmployeeCovarage={resBuildmngCovarage}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> پوشش بیمه</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"پوشش بیمه"}
                                                                                          value={selectedKind}
                                                                                          onChange={this.handleKind}
                                                                                          options={optionKind}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد پوشش"
                                                                                    handleInputt={this.handleChangeExtrafinancialPrice}
                                                                                    value={resbuildmng_price_covarage_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResbuildmngCoverage}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/*    RANGE DICOUNT  */}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resbuildmngBuildingTypeOfCons_discount.map((bfm, index) => (

                                                                    <ResBossToEmployeeRangeDiscount
                                                                        resBuildmngFinanceMedic={bfm}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>

                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>

                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="از متر مربع "
                                                                                handleInputt={this.handleChangeFromUnit_discount}
                                                                                value={from_area_discount}
                                                                            />
                                                                      </Grid>
                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder=" تا متر مربع "
                                                                                handleInputt={this.handleChangeToUnit_discount}
                                                                                value={to_area_discount}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder=" درصد تخفیف "
                                                                                handleInputt={this.handleChangeAmount_discount}
                                                                                value={percent_range_discount}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={2}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngFinanceMedic_discount}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    {/*    TYPE OF View BUILDING   */}
                                    <Grid item xs={12} >
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resbuildmngBuildingTypeOfCons.map((resbuildmngBuildingTypeOfCons, index) => (
                                                                    <ResBossToEmployeeSelectabelDiscount
                                                                        resbuildmngBuildingTypeOfCons={resbuildmngBuildingTypeOfCons}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={5}>
                                                                            <div>
                                                                                  <label className="on">نام تخفیف</label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={"نام تخفیف"}
                                                                                      value={selectedResbuildmngBuildingُTypeOfCons}
                                                                                      onChange={this.handleResbuildmngBuildingTypeOfCons}
                                                                                      options={optionResbuildmngBuildingTypeOfCons}
                                                                                  />
                                                                            </div>
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder="درصد تخفیف"
                                                                                handleInputt={this.handleChangeResbuildmngBuildingTypeOfCons}
                                                                                value={resbuildmng_price_typeofcons_percent}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={3}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngBuildingTypeOfCons}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/* THE PRICE*/}
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "boss_to_employee_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی قیمت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_id"}
                                                                                          direction={orderBy === "boss_to_employee_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("boss_to_employee_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>






                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_atonement_solvent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"دیه ماه حلال"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_atonement_solvent"}
                                                                                          direction={
                                                                                                orderBy === "boss_to_employee_price_atonement_solvent"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("boss_to_employee_price_atonement_solvent")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_coef_atonement_solvent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"ضریب دیه ماه حلال"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_coef_atonement_solvent"}
                                                                                          direction={
                                                                                                orderBy === "boss_to_employee_price_coef_atonement_solvent"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("boss_to_employee_price_coef_atonement_solvent")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_illegal_solvent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"دیه ماه حرام"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_illegal_solvent"}
                                                                                          direction={
                                                                                                orderBy === "boss_to_employee_price_illegal_solvent"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "boss_to_employee_price_illegal_solvent"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"boss_to_employee_price_coef_illegal_solvent"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"ضریب دیه ماه حرام"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "boss_to_employee_price_coef_illegal_solvent"}
                                                                                        direction={
                                                                                              orderBy === "boss_to_employee_price_coef_illegal_solvent"
                                                                                                  ? order
                                                                                                  : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler(
                                                                                                  "boss_to_employee_price_coef_illegal_solvent"
                                                                                              )
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_alpha"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"آلفا"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_alpha"}
                                                                                          direction={
                                                                                                orderBy === "boss_to_employee_price_alpha" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("boss_to_employee_price_alpha")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"resbuildmng_price_chashdisc"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف "}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "resbuildmng_price_chashdisc"}
                                                                                        direction={
                                                                                              orderBy === "resbuildmng_price_chashdisc" ? order : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("resbuildmng_price_chashdisc")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"boss_to_employee_price_deactive	"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "boss_to_employee_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "boss_to_employee_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("boss_to_employee_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["boss_to_employee_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"boss_to_employee_price_id"} align={"center"}>
                                                                                                      {row["boss_to_employee_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>



                                                                                                <TableCell
                                                                                                      key={"boss_to_employee_price_atonement_solvent"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["boss_to_employee_price_atonement_solvent"]}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                      key={"boss_to_employee_price_coef_atonement_solvent"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["boss_to_employee_price_coef_atonement_solvent"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"boss_to_employee_price_illegal_solvent"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["boss_to_employee_price_illegal_solvent"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"boss_to_employee_price_coef_illegal_solvent"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["boss_to_employee_price_coef_illegal_solvent"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"boss_to_employee_price_alpha"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["boss_to_employee_price_alpha"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"resbuildmng_price_chashdisc"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_chashdisc"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_deactive"] === "1" ||
                                                                                                      row["resbuildmng_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه مدیر ساختمان را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceResbuildmng)
